import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ApplianceGroup } from '@shared/models/dataref.model';
import { ApplianceGroupDurationsLite } from '@shared/models/generic/appliance-group-durations-lite.model';

@Component({
  selector: 'app-time-inputs',
  templateUrl: './time-inputs.component.html',
  styleUrls: ['./time-inputs.component.scss'],
  standalone: false,
})
export class TimeInputsComponent implements OnChanges {
  @Input() formVariant?: UntypedFormGroup;
  @Input() applianceGroupsList?: ApplianceGroup[];
  @Input() updateComponent?: boolean;
  hourText = 'h';
  minText = 'm';
  durations: {
    prepTime: number | string;
    cookingTime: number | string;
    applianceGroupDurations?: ApplianceGroupDurationsLite[];
    offApplianceCookingTime: number | string;
    restingTime: number | string;
    totalTime: number | string;
  } = {
      prepTime: 0,
      cookingTime: 0,
      offApplianceCookingTime: 0,
      restingTime: 0,
      totalTime: 0,
    };
  timeMask = '00h00m';
  timePatterns = {
    '0': { pattern: /\d/ },
  };
  specialCharacters = ['h', 'm'];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.formVariant?.currentValue) {
      this.durations = { ...changes.formVariant?.currentValue.controls.durations.value };
      this.initDuration();
    }
    if (changes.updateComponent) {
      this.durations = { ...this.formVariant?.controls.durations.value };
      this.initDuration();
    }
  }

  initDuration(): void {
    this.durations.prepTime = this.convertMinToHoursMin('' + this.durations.prepTime);
    this.durations.cookingTime = this.convertMinToHoursMin('' + this.durations.cookingTime);
    this.durations.offApplianceCookingTime = this.convertMinToHoursMin('' + this.durations.offApplianceCookingTime);
    this.durations.restingTime = this.convertMinToHoursMin('' + this.durations.restingTime);
    this.durations.totalTime = this.convertMinToHoursMin('' + this.durations.totalTime);
  }

  convertMinToHoursMin(min: string): string {
    const hours = Math.floor(Number(min) / 60);
    const minutes = Number(min) - hours * 60; // remove hours of min
    let time = hours > 0 ? hours.toString().padStart(2, '0') : '00';
    time += 'h';
    time += minutes > 0 ? minutes.toString().padStart(2, '0') : '00';
    time += 'm';
    return time;
  }

  applianceText(key: string): string | undefined {
    const applianceIndex = this.applianceGroupsList?.findIndex((appliance: ApplianceGroup) => appliance.key === key);
    return applianceIndex !== undefined && applianceIndex >= 0 && this.applianceGroupsList
      ? this.applianceGroupsList[applianceIndex].labelInt
      : key;
  }

  changeTime(a: HTMLInputElement, b: string): void {
    const timeMin = '' + a.value;
    const duration = this.formVariant?.controls.durations.value;
    duration[b] = timeMin.replace(this.hourText, '').replace(this.minText, '');
    duration[b] = Number(duration[b].substr(0, 2)) * 60 + Number(duration[b].substr(2, 2));
    this.formVariant?.controls.durations.setValue(duration);
    a.value = this.convertMinToHoursMin(duration[b]);

    if (b === 'cookingTime') {
      // dont change time in applianceGroupDurations
      const totalTime = duration.offApplianceCookingTime + duration.restingTime + duration.cookingTime + duration.prepTime;
      this.durations.totalTime = this.convertMinToHoursMin('' + totalTime);
    } else {
      this.calculateTotalTime();
    }

    a.dispatchEvent(new Event('input'));
    this.formVariant?.controls.durations.markAsDirty();
  }

  calculateTotalTime(): void {
    const duration = this.formVariant?.controls.durations.value;
    let totalTimeDefault = duration.totalTime;
    duration.applianceGroupDurations.forEach((applianceGroup: ApplianceGroupDurationsLite) => {
      const totalTime = duration.offApplianceCookingTime + duration.restingTime + applianceGroup.cookingTime + duration.prepTime;
      if (applianceGroup.applianceGroup === this.formVariant?.controls.defaultApplianceGroup.value) {
        totalTimeDefault = totalTime;
      }
      applianceGroup.totalTime = totalTime;
    });
    duration.totalTime = totalTimeDefault;
    this.durations.totalTime = this.convertMinToHoursMin('' + totalTimeDefault);
  }
}
